
import Vue from 'vue';

interface ISearchTitleComputed {
  query: string;
}

export default Vue.extend<{}, {} ,ISearchTitleComputed ,{} >({
	name: 'SearchTitle',
	computed: {
    query() {
      // let urlQuery = new URL(location.href).searchParams.get("query");
      // this.$store.commit({
      //   type: 'setQuery',
      //   payload: urlQuery
      // })
      return this.$store.getters.query || 'Sökt fras';
    }
	},
})
